import axios from 'axios';

export default function currencySelector() {

  const client = axios.create({
    headers: {
      'X-CSRF-Token': window.csrfToken,
      'Content-type': 'application/json'
    }
  });

  /** currency selections */
  const select = document.querySelector('div.header-currency-selector select');
  select.addEventListener('change', event => {

    // call controller to set the currency...
    client.post(
      '/set-currency',
      { 
        CSRF_TOKEN: window.csrfToken,
        code: event.target.value
      }
    )
    .then(function (response) { /**/ })
    .catch(function (error) { /**/ })
    .finally(function () {
      document.location = `${document.location.href}`;
    });
  });
}


// WEBPACK FOOTER //
// ./source/scripts/sections/currencySelector.js